import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0055',
    ecrans: ['00-2', '01-2'],
    params: ['id', '?ajocleintref', '?daccleint', '?etccleint', '?isforage', '?mnetab']
});
